/** Экран 8 — отчёт о розыгрыше. */
import { Badge, BrandMark, Card, Empty, Hash, KeyRow, Skeleton, fmtDateTime, num } from '@allswipes/ui';
import { Link, useParams } from 'react-router-dom';

import { api } from '../api';
import { Shell } from '../components/Shell';
import { useResource } from '../hooks';

import { useT } from '@allswipes/i18n';

export function DrawReportScreen() {
  const t = useT();
  const { id = '' } = useParams();
  const report = useResource(() => api.drawReport(id), [id]);

  if (report.loading) {
    return (
      <Shell title={t('Отчёт о розыгрыше')}>
        <Skeleton count={2} height={140} />
      </Shell>
    );
  }
  if (report.error || !report.data) {
    return (
      <Shell title={t('Отчёт о розыгрыше')}>
        <Empty icon="trophy" title={t('Отчёт не найден')}>
          {report.error}
        </Empty>
      </Shell>
    );
  }

  const { campaign: c, fair, winners = [] } = report.data;

  return (
    <Shell title={t('Отчёт о розыгрыше')} subtitle={c.name}>
      <div className="stack">
        <Card>
          <div className="row" style={{ marginBottom: 10 }}>
            <BrandMark name={c.prefix} size={30} />
            <span className="h2" style={{ flex: 1 }}>
              {c.prize_title}
            </span>
            <Badge tone="good">{c.status === 'drawn' ? t('проведён') : t('ожидается')}</Badge>
          </div>
          <KeyRow label={t('Дата розыгрыша')}>{c.draw_at ? fmtDateTime(c.draw_at) : '—'}</KeyRow>
          <KeyRow label={t('Участников')}>{num(c.participants)}</KeyRow>
          <KeyRow label={t('Билетов')}>{num(c.tickets)}</KeyRow>
          <KeyRow label={t('Призов')}>{num(c.winner_count)}</KeyRow>
        </Card>

        {fair && (
          <Card>
            <div className="h2" style={{ marginBottom: 10 }}>
              {t('Входные данные розыгрыша')}
            </div>
            <KeyRow label={t('Алгоритм')}>{fair.algo_version}</KeyRow>
            <KeyRow label={t('Хеш сида сервера')} mono>
              <Hash value={fair.server_seed_hash} />
            </KeyRow>
            {fair.server_seed && (
              <KeyRow label={t('Сид сервера (раскрыт)')} mono>
                <Hash value={fair.server_seed} />
              </KeyRow>
            )}
            {fair.ticket_root && (
              <KeyRow label={t('Корень списка билетов')} mono>
                <Hash value={fair.ticket_root} />
              </KeyRow>
            )}
            {fair.external_value && (
              <KeyRow
          label={`${t('Публичный сид')}${fair.external_source ? ` · ${fair.external_source}` : ''}`}
        >
                {fair.external_value}
              </KeyRow>
            )}
            {fair.frozen_at && <KeyRow label={t('Список зафиксирован')}>{fmtDateTime(fair.frozen_at)}</KeyRow>}
            {fair.revealed_at && <KeyRow label={t('Сид раскрыт')}>{fmtDateTime(fair.revealed_at)}</KeyRow>}

            <p className="sub" style={{ marginTop: 12 }}>
              {t('Список билетов зафиксирован раньше, чем объявлен публичный сид. Поэтому ни бренд, ни платформа не могли подогнать ни состав участников, ни случайность.')}
            </p>
            <Link to={`/verify/${c.id}`} className="btn pri block" style={{ marginTop: 12 }}>
              {t('Пересчитать самому')}
            </Link>
          </Card>
        )}

        <Card>
          <div className="h2" style={{ marginBottom: 10 }}>
            {t('Победители')}
          </div>
          {winners.length === 0 ? (
            <Empty title={t('Победителей нет')}>
              {t('По этой акции не было ни одного билета — сид всё равно раскрыт, чтобы отсутствие победителей можно было проверить так же, как их наличие.')}
            </Empty>
          ) : (
            winners.map((w) => (
              <div className="wrow" key={w.position}>
                <span className="rk">#{w.position}</span>
                <span className="num">{w.ticket_number}</span>
                {w.prize_label && <span className="rg">{w.prize_label}</span>}
                {w.region && <span className="rg">{w.region}</span>}
              </div>
            ))
          )}
        </Card>
      </div>
    </Shell>
  );
}
